import { Field, FieldType } from "@/core/types/types";

export enum FieldName {
  CustomerFirstName = "customerFirstName",
  CustomerLastName = "customerLastName",
}

export const fields: { [key in FieldName]: Field } = {
  [FieldName.CustomerFirstName]: {
    id: FieldName.CustomerFirstName,
    key: FieldName.CustomerFirstName,
    label: "customerContactInfo.firstName",
    type: FieldType.TextField,
    properties: {},
    validate: {
      required: true,
    },
  },
  [FieldName.CustomerLastName]: {
    id: FieldName.CustomerLastName,
    key: FieldName.CustomerLastName,
    label: "customerContactInfo.lastName",
    type: FieldType.TextField,
    properties: {},
    validate: {
      required: true,
    },
  },
};
